var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loginRegister"}},[_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":function($event){return _vm.login()}}},[_vm._v(_vm._s(this.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }